<template>
    <v-select
            v-bind="$props"
            v-on="$listeners"
    ></v-select>
</template>

<script>
    export default {
        name: "SSelect",
        props: {
            'value': {type:[String, Number, Boolean]},
            'name':String,
            'label': String,
            'prepend-icon': String,
            'append-icon':String,
            'items': Array,
            'rules': Array,
            itemText: String,
            itemValue: String,
            disabled: Boolean,
            clearable:{type:Boolean, default:false},
            'browser-autocomplete': {type:String, default: 'on'}
        },
    }
</script>

<style scoped>

</style>
